'use strict'

const guid = function () {
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

const uniqid = function () {
	return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4()
}

const dtunid = function () {
	return Date.now() + '-' + uniqid()
}
const dtguid = function () {
	return Date.now() + '-' + guid()
}

const s4 = function () {
	return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
}
export {
	guid,
	uniqid,
	dtunid,
	dtguid,
	s4,
}